export default "__VITE_ASSET__CL$ThwGP__"